import BaseService from '@/services/BaseService';
const MASTER_TAPE_MAPPINGS_BASE = 'master-tape-mappings-pivoted';

export type MasterTapeMappingsTapeKind =
  | 'aviation'
  | 'marine'
  | 'railcar'
  | 'triple-net-lease'
  | 'non-us-resi'
  | 'non-us-cre'
  | 'sme'
  | 'private-credit-finance'
  | 'fund-finance'
  | 'student-loan';

export type MasterTapeMappingColumnMeta = {
  field: string;
  headerName: string;
  group?: string | null;
};

/** HTTP client for `master-tape-mappings-pivoted/{tapeKind}` column metadata and SSRM grids. */
export class MasterTapeMappingsService extends BaseService {
  constructor() {
    super('/api/digitalconnect-service');
  }

  resolveColumnsPath = (tapeKind: MasterTapeMappingsTapeKind): string => {
    return `${MASTER_TAPE_MAPPINGS_BASE}/${tapeKind}/columns`;
  };

  resolveSsrmEndpoint = (tapeKind: MasterTapeMappingsTapeKind): string => {
    return `${MASTER_TAPE_MAPPINGS_BASE}/${tapeKind}`;
  };

  fetchColumns = async (tapeKind: MasterTapeMappingsTapeKind): Promise<MasterTapeMappingColumnMeta[]> => {
    const response = await this.get({ path: this.resolveColumnsPath(tapeKind) });
    return Array.isArray(response) ? response : [];
  };
}
